import "@/App.css";
import Nav from "@/components/site/Nav";
import Preloader from "@/components/site/Preloader";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Projects from "@/components/site/Projects";
import Experience from "@/components/site/Experience";
import Skills from "@/components/site/Skills";
import Approach from "@/components/site/Approach";
import Stats from "@/components/site/Stats";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";

function App() {
  return (
    <div className="site" data-testid="app-root">
      <Preloader />
      <Nav />
      <main>
        <Hero />
        <div className="relative z-10 bg-[var(--bg)]">
          <Marquee />
          <Services />
          <Projects />
          <Experience />
          <Skills />
          <Approach />
          <Stats />
          <About />
          <Contact />
        </div>
      </main>
    </div>
  );
}

export default App;
